import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeroSearchForm from "./HeroSearchForm";
import { AnimatePresence, motion } from "framer-motion";

// img
import HeroBottomImg from "../../images/hero-bottom.png";

// Tab configuration for Buy, Sell, Rent
const TABS = [
  { title: "Buy", key: "buy", content: <HeroSearchForm /> },
  { title: "Sell", key: "sell", content: <HeroSearchForm /> },
  { title: "Rent", key: "rent", content: <HeroSearchForm /> },
];

export default function HeroSection3() {
  const [activeTab, setActiveTab] = useState("buy");
  return (
    <>
      <section className="hero-section hero-section-three" id="home3">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="hero-section-main-content">
                <div className="hero-section-content text-center w-100 position-relative">
                  {/* Apply animation on the main content of the section */}
                  <Row className="justify-content-center">
                    <Col lg={12} xl={10} xxl={8}>
                      <motion.div
                        whileInView={{ scale: 1 }}
                        initial={{ scale: 0.8 }}
                        transition={{
                          type: "linear",
                          stiffness: 100,
                          duration: 1,
                        }}
                      >
                        {/* Main title with a highlighted word "Dreamed" */}
                        <h1 className="hero-title fw-normal display-4 mb-0">
                          Explore the Home You’ve Always{" "}
                          <span className="text-primary">Dreamed</span> of
                          Living In
                        </h1>
                        {/* Description paragraph */}
                        <p className="fs-18 text-white opacity-85 mt-4 pt-1 mb-50">
                          Discover a place where your dream home becomes a reality. With thoughtful design & unmatched comfort, we bring you spaces that perfectly fit your lifestyle and aspirations.
                        </p>
                      </motion.div>
                    </Col>
                  </Row>
                  {/* Tab navigation */}
                  <Row className="justify-content-center">
                    <div className="position-relative mt-2">
                      <ul className="nav nav-tabs justify-content-center hero-tab-filter" role="tablist">
                        {/* Generate tabs dynamically */}
                        {TABS.map((tab) => (
                          <li className="nav-item" role="presentation" key={tab.key}>
                            <button
                              className={`nav-link ${activeTab === tab.key ? "active" : ""
                                }`}
                              id={`${tab.key}-tab`}
                              data-bs-toggle="tab"
                              type="button"
                              role="tab"
                              onClick={() => setActiveTab(tab.key)}
                            >
                              {tab.title}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* Tab content section */}
                      <div className="tab-content hero-tab-content">
                        <AnimatePresence mode="wait">
                          {/* Animate content based on the active tab */}
                          {TABS.map(
                            (tab) =>
                              tab.key === activeTab && (
                                <motion.div
                                  key={tab.key}
                                  className="tab-pane active"
                                  role="tabpanel"
                                  initial={{ opacity: 0, y: 20 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: -20 }}
                                  transition={{
                                    duration: 0.4,
                                    ease: "easeInOut",
                                  }}
                                >
                                  {tab.content} {/* Render the content of the active tab */}
                                </motion.div>
                              )
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="border-bottom hero3-bottom-img">
          <Row>
            <Col md={12}>
              <img src={HeroBottomImg} alt="" className="w-100" />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
